export default function RateAgreementStep({ value, errors, onChange }) {
  const set = (patch) => onChange(patch);

  return (
    <section className="card">
      <h2>Acuerdo Tarifario</h2>

      {/* ===============================
          DATOS GENERALES
         =============================== */}

      {/* Nombre */}
      <Field
        label="Nombre del acuerdo"
        required
        error={errors.name}
        help="Nombre descriptivo del acuerdo tarifario."
      >
        <input
          type="text"
          placeholder="Tarifa Taxi AMCO 2025"
          value={value.name}
          onChange={(e) => set({ name: e.target.value })}
        />
      </Field>

      {/* Número */}
      <Field
        label="Número de acuerdo"
        required
        error={errors.number}
      >
        <input
          type="number"
          min={1}
          step={1}
          placeholder="1"
          value={value.number}
          onChange={(e) => set({ number: e.target.value })}
        />
      </Field>

      {/* Año */}
      <Field
        label="Año"
        required
        tooltip="Debe coincidir normalmente con el año de expedición."
        error={errors.year}
      >
        <input
          type="number"
          min={1900}
          max={2100}
          placeholder="2025"
          value={value.year}
          onChange={(e) => set({ year: e.target.value })}
        />
      </Field>

      <hr />

      {/* ===============================
          FECHAS OFICIALES
         =============================== */}

      {/* Fecha de expedición */}
      <Field
        label="Fecha de expedición"
        required
        error={errors.issued_at}
      >
        <input
          type="date"
          value={value.issued_at}
          onChange={(e) => set({ issued_at: e.target.value })}
        />
      </Field>

      {/* Vigente desde */}
      <Field
        label="Vigente desde"
        required
        error={errors.effective_from}
      >
        <input
          type="date"
          value={value.effective_from}
          onChange={(e) => set({ effective_from: e.target.value })}
        />
      </Field>

      {/* Vigente hasta */}
      <Field
        label="Vigente hasta"
        error={errors.effective_to}
      >
        <input
          type="date"
          disabled={value.no_end_date}
          min={value.effective_from || undefined}
          value={value.effective_to}
          onChange={(e) => set({ effective_to: e.target.value })}
        />

        <label className="checkbox">
          <input
            type="checkbox"
            checked={value.no_end_date}
            onChange={(e) =>
              set({
                no_end_date: e.target.checked,
                effective_to: "",
              })
            }
          />
          Sin fecha de fin
        </label>
      </Field>

      {/* Error cruzado de fechas */}
      {errors.date_range && (
        <div className="error-box">
          {errors.date_range}
        </div>
      )}

      {/* ===============================
          DOCUMENTO SOPORTE
         =============================== */}

      <Field
        label="Documento del acuerdo (opcional)"
        error={errors.document_url}
        help="Resolución, decreto o acto administrativo que respalda esta tarifa."
      >
        <input
          type="url"
          placeholder="https://..."
          value={value.document_url}
          onChange={(e) => set({ document_url: e.target.value })}
        />
      </Field>

      {/* ===============================
          MENSAJE INFORMATIVO (CORRECTO)
         =============================== */}
      <div className="info-box">
        ℹ️ Al continuar se creará el acuerdo tarifario. Podrá completar la
        información y guardarla como borrador en los siguientes pasos.
      </div>
    </section>
  );
}

/* ===============================
   Helper Field
   =============================== */

function Field({ label, required, tooltip, error, help, children }) {
  return (
    <div className={`field ${error ? "has-error" : ""}`}>
      <label title={tooltip}>
        {label} {required && <span>*</span>}
        {tooltip && <small> ⓘ {tooltip}</small>}
      </label>

      {children}

      {help && !error && <small>{help}</small>}
      {error && <small className="error">{error}</small>}
    </div>
  );
}
